import { render, staticRenderFns } from "./editAndDeleteKiosk.vue?vue&type=template&id=4713cde8"
import script from "./editAndDeleteKiosk.vue?vue&type=script&lang=js"
export * from "./editAndDeleteKiosk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports